export default __webpack_public_path__ + "static/media/10-oz-pamp-suisse-lady-fortuna-gold-bar-9999-fine-in-assay--132084758245794779.b8ef19ce.jpg";